import React from "react";
import { Divider, Item, List, Message, Tab, Table } from "semantic-ui-react";

export const PaneSystem = (props) => {
  const { systems } = props;

  const systemTables = systems.map((system, i) => {
    return (
      <div key={i}>
        <h3>System {i + 1}</h3>
        <Table className="capitalize" celled compact striped color="blue">
          <Table.Body>
            <Table.Row>
              <Table.Cell content="Name" />
              <Table.Cell content={system.name} />
            </Table.Row>
            <Table.Row>
              <Table.Cell content="Type" />
              <Table.Cell content={system.variety_formatted} />
            </Table.Row>
            {![15, 16].includes(system.component_code) && (
              <React.Fragment>
                <Table.Row>
                  <Table.Cell content="Fuel" />
                  <Table.Cell content={system.fuel_formatted} />
                </Table.Row>
                <Table.Row>
                  <Table.Cell content="Tonnage" />
                  <Table.Cell content={system.tonnage_formatted} />
                </Table.Row>
              </React.Fragment>
            )}
            {system.seer_formatted ? (
              <Table.Row>
                <Table.Cell content="Seer" />
                <Table.Cell content={system.seer_formatted} />
              </Table.Row>
            ) : null}
            <Table.Row>
              <Table.Cell content="Customer's Cost" />
              <Table.Cell content={`$${system.price_formatted}`} />
            </Table.Row>
            <Table.Row>
              <Table.Cell content="Dealer Payout" />
              <Table.Cell content={`$${system.dealer_payout_formatted}`} />
            </Table.Row>
          </Table.Body>
        </Table>
        <Divider hidden />
      </div>
    );
  });

  return (
    <Tab.Pane>
      {systems.length === 0 ? (
        <Message
          warning
          header="No System Info Available"
          content="System data could not be found for this contract"
          icon="question"
        />
      ) : (
        <Item.Group>
          <Item.Content>
            <Item.Description>{systemTables}</Item.Description>
          </Item.Content>
        </Item.Group>
      )}
    </Tab.Pane>
  );
};
